import { useQuery } from "react-query";
import AttendanceApiClient from "api/AttendanceApiClient";

export function useRegionSchoolsAttendance(regionId) {
    return useQuery(["regionSchoolsAttendance", { regionId }], () =>
        AttendanceApiClient.getRegionSchoolsAttendance(regionId),
    );
}
